export default defineNuxtRouteMiddleware((to) => {
    try {
        const config = useRuntimeConfig()
        const customProviderModeId =
            config.public.customProviderModeId || 'default'

        let defaultProviderPage = '/'
        let allowedRoutes: string[] = []

        // FULL APP MODE
        if (customProviderModeId === 'default') {
            allowedRoutes = []
        }

        // CUSTOM PROVIDER MODE
        else if (customProviderModeId) {

            defaultProviderPage = `/store/${customProviderModeId}`

            // Redirect homepage → provider page
            if (to.path === '/') {
                return navigateTo(defaultProviderPage)
            }

            // Prevent accessing other providers
            if (
                to.path.startsWith('/providers') &&
                to.path !== defaultProviderPage
            ) {
                return navigateTo(defaultProviderPage)
            }

            allowedRoutes = [
                defaultProviderPage,
                '/products/*',
                '/about/*',
                '/cart',
                '/sso',
                '/map',
                '/order-summary',
                '/account/*',
                '/coupons',
                '/nups/callback',
                '/login-success',
            ]
        }

        // Route validator
        const isAllowed = (path: string) => {
            if (allowedRoutes.length === 0) return true

            return allowedRoutes.some((route) => {
                if (route.includes('*')) {
                    const pattern = new RegExp('^' + route.replace('*', '.*') + '$')
                    return pattern.test(path)
                }
                return route === path
            })
        }

        if (!isAllowed(to.path)) {
            return navigateTo(defaultProviderPage)
        }

    } catch (error) {
        return navigateTo('/')
    }
})